<script setup lang="ts">
const phoneNumber = "34623929657";
const waLink = `https://wa.me/${phoneNumber}`;
</script>

<template>
  <div class="whatsapp-wrapper">
    <a
      :href="waLink"
      class="whatsapp-float"
      target="_blank"
      aria-label="Chat en WhatsApp"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="white">
        <path
          d="M256.064 0C114.784 0 0 114.848 0 256.192c0 45.216 11.84 89.408 34.368 127.968L0 512l132.416-34.88c36.672 20.064 78.144 30.72 120.288 30.72h.032c141.248 0 256.064-114.848 256.064-256.192C508.8 114.848 393.984 0 256.064 0zm0 472.704c-37.344 0-73.824-10.048-105.792-29.024l-7.584-4.512-78.624 20.704 21.056-76.544-4.928-7.872c-21.504-34.304-32.864-73.92-32.864-114.304 0-119.68 97.344-217.024 217.024-217.024 57.968 0 112.48 22.592 153.344 63.488 40.832 40.896 63.36 95.52 63.36 153.6 0 119.68-97.344 217.024-217.024 217.024zm119.04-162.528c-6.512-3.264-38.4-18.944-44.352-21.056-5.952-2.112-10.304-3.264-14.656 3.264-4.352 6.4-16.832 21.056-20.608 25.408-3.776 4.32-6.976 4.8-13.488 1.536-6.4-3.264-27.008-9.92-51.392-31.68-19.008-17.024-31.84-38.016-35.616-44.416-3.776-6.4-.4-9.92 2.848-13.12 2.912-2.912 6.4-7.584 9.6-11.328 3.2-3.776 4.352-6.4 6.512-10.752 2.112-4.32 1.056-8.064-.528-11.328-1.6-3.264-14.656-35.2-20.096-48.064-5.312-12.8-10.688-11.008-14.656-11.2-3.776-.16-8.064-.192-12.384-.192s-11.328 1.6-17.28 8.064c-5.952 6.4-22.784 22.272-22.784 54.4s23.296 63.136 26.528 67.456c3.264 4.32 45.92 70.112 111.328 98.368 15.552 6.72 27.712 10.72 37.184 13.696 15.616 4.992 29.824 4.288 41.024 2.592 12.512-1.856 38.4-15.68 43.808-30.784 5.376-15.104 5.376-28.032 3.776-30.784-1.6-2.688-5.856-4.32-12.384-7.584z"
        />
      </svg>
      <span class="tooltip">Escríbenos</span>
    </a>
  </div>
</template>

<style scoped lang="scss">
.whatsapp-wrapper {
  position: fixed;
  bottom: 30px;
  right: 20px;
  z-index: 999;
}

.whatsapp-float {
  position: relative;
  background-color: #25d366;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);

    .tooltip {
      opacity: 1;
      transform: translateX(-10px);
      visibility: visible;
    }
  }

  svg {
    width: 42px;
    height: 42px;
  }

  .tooltip {
    position: absolute;
    right: 90px;
    background-color: #25d366;
    color: white;
    padding: 6px 10px;
    border-radius: 20px;
    font-size: 14px;
    white-space: nowrap;
    opacity: 0;
    transform: translateX(0);
    transition: all 0.3s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    pointer-events: none;
    visibility: hidden;

    @media (max-width: 768px) {
      display: none;
    }
  }
}
</style>
